var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHorizontalBlueLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 329,
    height: 120,
    viewBox: "0 0 329 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12546_45582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.3594 117.64C66.3594 106.7 66.3594 95.8802 66.3594 84.9302C75.3094 90.4002 84.1794 95.8302 93.1894 101.34C84.1994 106.8 75.3194 112.19 66.3594 117.64Z",
    fill: "#D62237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.51 29.98L51.75 0L0 29.91V89.77L51.75 119.63L62.11 113.65V77.78L93.19 95.7L103.55 89.72L103.51 29.98ZM62.11 65.86L51.75 59.81V107.65L10.38 83.78V71.82L20.74 77.76V65.83L10.38 59.89V47.92L41.39 65.81V53.83L10.38 35.87L26.04 26.9L67.34 50.74V38.96L36.05 21.02L51.75 11.91L93.18 35.88L93.19 83.76L62.11 65.86Z",
    fill: "url(#paint0_linear_12546_45582)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.639 30.52V74.4L278.779 30.52H267.679V79.73H211.339V63.95H246.909V63.41V54.03V53.57H211.339V40.9H257.299V30.52H200.669H130.379V40.9H154.869V89.1H165.539V40.9H200.669V89.1H267.679H278.349V45.1L317.539 89.1H328.309V30.52H317.639Z",
    fill: "url(#paint1_linear_12546_45582)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12546_45582",
    x1: 0,
    y1: 59.8129,
    x2: 103.547,
    y2: 59.8129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10074D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1289,
    stopColor: "#110950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2976,
    stopColor: "#131159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4884,
    stopColor: "#162168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6954,
    stopColor: "#19397F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9133,
    stopColor: "#1D5C9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F6DAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12546_45582",
    x1: 130.375,
    y1: 59.8129,
    x2: 328.311,
    y2: 59.8129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10074D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1289,
    stopColor: "#110950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2976,
    stopColor: "#131159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4884,
    stopColor: "#162168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6954,
    stopColor: "#19397F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9133,
    stopColor: "#1D5C9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F6DAF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12546_45582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 328.31,
    height: 119.63,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalBlueLogo);
export default __webpack_public_path__ + "static/media/horizontal-blue-logo.e3ca0a6cf2fd64534811a5c580e00570.svg";
export { ForwardRef as ReactComponent };